import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { map, take } from 'rxjs';

export function isAgentGuard(redirectTo = '/'): CanActivateFn {
  return () => {
    const router = inject(Router);
    const profileContextService = inject(DashboardProfileContextService);

    return profileContextService.isIndividual$.pipe(
      take(1),
      map((isIndividual) => {
        if (isIndividual) {
          return true;
        }

        return new RedirectCommand(router.parseUrl(redirectTo), {
          skipLocationChange: false,
        });
      }),
    );
  };
}
